import React from 'react';
import { useStyles } from '../../styles';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import EventCards from '../EventCards';
import { EventActionHeaderProps } from '../../utils/interfaces';
import { FilterCells } from '../../globalComponent/AppFilter';
import routes from '../../../../Utils/routes';

import KenColors from '../../utils/kenColors';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

const EventActionHeaderMobile: React.FunctionComponent<EventActionHeaderProps> = (props) => {
  const { filterData, handleFilerRemove, eventsData, handleFilterOpen, title, filterButtonDisable } = props;
  const classes = useStyles();

  return (
    eventsData.length > 0 && (
      <Box width={'100%'}>
        <Box component={'div'}>
          {Object.keys(filterData).length > 0 && filterButtonDisable ? (
            <div className={classes.cellsContainer}>
              <FilterCells
                cellsArray={filterData}
                handleFilerRemove={(key) => {
                  handleFilerRemove(key);
                }}
              />
            </div>
          ) : (
            <Grid container justifyContent="space-between" alignItems="center">
              
              <Typography className={classes.registeredEventsHeading}>
                {title} ({eventsData?.length})
              </Typography>
              
              <Button
                  style={{ textTransform: 'capitalize' }}
                  size="small"
                  onClick={() => {
                    handleFilterOpen();
                  }}
                  variant="contained"
                  startIcon={
                    <FilterAltOutlinedIcon
                      sx={{
                        fontSize: { xs: '20px', sm: '22px', md: '26px', lg: '28px' },
                        color: KenColors.ClientBlack2,
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '15px',
                        },
                      }}
                    />
                  }
                  className={classes.filterBtn}
                >
                  Filters
                </Button>
            </Grid>
          )}
        </Box>
        <Paper className={`${classes.cardHolder}`}>
          <Grid lg={12} container spacing={1} mt={2}>
            {eventsData &&
              (eventsData).map((items: any, index: number) => {
                return (
                  <Grid item md={8} lg={4} xs={6} sm={2} key={index}>
                    <EventCards {...items} key={index} />
                  </Grid>
                );
              })}
          </Grid>
        </Paper>
      </Box>
    )
  );
};

export default EventActionHeaderMobile;
